export const nutritionPlan = {
  header: {
    title: 'Dein 30-Tage-Ernährungsplan',
    lastUpdated: 'Zuletzt aktualisiert: {{date}}',
    downloadPdf: 'PDF herunterladen',
    changePlan: 'Plan ändern',
    activatePlan: "Plan aktivieren",
    noHistoryFound: "Keine Historie gefunden",
    active: "Aktiv",
    selectPlan: "Einen Plan auswählen",
    historyLockedTitle: 'Planverlauf',
    historyLockedDescription:
      'Wechsle zu VIP, um fr\u00fchere Ern\u00e4hrungspl\u00e4ne zu durchsuchen und wiederherzustellen.',
  },
  viewMode: {
    calendar: 'Kalenderansicht',
    list: 'Listenansicht',
    currentDay: 'Aktueller Tag:',
    day: 'Tag',
  },
  overview: {
    title: 'Plan-Übersicht',
    basicPlan: 'Basic Plan',
    vipPlan: 'VIP Plan',
    goal: 'Ziel:',
    goalValue: 'Abnehmen',
    calorieTarget: 'Kalorienziel:',
    calorieValue: '1520 kcal/Tag',
    meals: 'Mahlzeiten:',
    mealsValue: '3 pro Tag',
    dietType: 'Ernährungstyp:',
    dietTypeValue: 'Vegetarisch',
    allergies: 'Allergien:',
    allergiesValue: 'Laktose',
    activityLevel: 'Aktivitätslevel:',
    activityLevelValue: 'Moderat',
    startDate: 'Startdatum:',
    startDateValue: '4. Januar 2025',
    endDate: 'Enddatum:',
    endDateValue: '2. Februar 2025',
    progress: 'Fortschritt:',
    progressValue: '{{current}} von {{total}} Tagen',
    perDay: 'pro Tag',
  },
  calendar: {
    title: '{{duration}}-Tage-Kalender',
    today: 'Heute',
    day: 'Tag',
  },
  list: {
    day: 'Tag',
    today: 'Heute - Tag {{day}}',
    dayLabel: 'Tag {{day}}',
    mealInfo: '3 Mahlzeiten • 1520 kcal • Klicken für Details',
    completed: 'Abgeschlossen',
    current: 'Aktuell',
  },
  info: {
    basicTitle: 'Basic Plan Hinweis',
    basicMessage: 'Mit dem Basic Plan erhältst du einen vollständigen 30-Tage-Plan. Änderungen sind erst nach Ablauf der 30 Tage möglich. Upgrade auf VIP für unbegrenzte Anpassungen, detaillierte Rezepte und PDF-Export!',
    vipTitle: 'VIP Vorteile aktiv',
    vipMessage: 'Du kannst deinen Plan jederzeit ändern, detaillierte Rezepte einsehen, PDFs herunterladen und Einkaufslisten erstellen. Nutze den Chat für persönliche Anpassungen!',
  },
  recipe: {
    calories: 'Kalorien',
    kcal: 'kcal',
    nutritionTitle: 'Nährwertangaben',
    protein: 'Protein',
    carbs: 'Kohlenhydrate',
    fat: 'Fett',
    ingredients: 'Zutaten',
    vipFeatureTitle: 'VIP Funktion',
    vipFeatureMessage: 'Upgrade auf VIP um detaillierte Zutaten und Anweisungen zu sehen.',
    servings: 'Portionen',
    portions: 'Portionen',
    totalTime: 'Gesamtzeit',
    minutes: 'Minuten',
    cuisine: 'Küche',
    dishType: 'Gericht',
    instructions: 'Anweisungen',
    viewFullRecipe: 'Vollständiges Rezept & Anweisungen ansehen',
    opensInNewTab: 'Öffnet in neuem Tab bei',
    weight: 'Gewicht',
    addToShoppingList: 'Zur Einkaufsliste hinzufügen',
    neverShowIngredient: 'Diese Zutat nie wieder anzeigen',
  },
  mealDetailModal: {
    todayMealPlan: "Heute {{dayNumber}} - Dein Ernährungsplan",
    completeOverviewOfMeals: "Vollständige Übersicht aller Mahlzeiten",
    editDay: "Tag bearbeiten",
    noMealsForDay: "Für diesen Tag wurden keine Mahlzeiten gefunden",
    dailySummary: "Tagesübersicht",
    totalCalories: "Gesamtkalorien",
    upgradeToVip: "Upgrade auf VIP für mehr Funktionen",
    vipFeaturesDescription: "PDF-Export, Einkaufslisten, detaillierte Rezepte und mehr!",
  },
  noActivePlan: {
    title: "Kein aktiver Ernährungsplan",
    subtitle: "Du hast noch keinen aktiven Ernährungsplan. Lass uns einen erstellen!",
    cta: "Meinen Plan mit KI erstellen",
    whatYouGet: "Das bekommst du",
    mealPlanDuration: "Personalisierter {{days}}-Tage-Ernährungsplan",
    tailored: "Abgestimmt auf deine Ziele und Ernährungsgewohnheiten",
    detailedRecipes: "Detaillierte Rezepte mit Anleitung",
    basicDescriptions: "Einfache Mahlzeitenbeschreibungen",
    aiModifications: "KI-gestützte Anpassungen jederzeit"
  }
};
